module.exports = __webpack_public_path__ + "img/error-404.41abe843.png";